export default "__VITE_ASSET__Bb1WQHd1__"